import React, { useState } from "react";

// @mui material components
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import config from "config/config";

import PropTypes from "prop-types";

// Images
import restaurantIcon from "assets/images/icons/catering-icons/restaurantIconBlue.svg";
import tooltipIcon from "assets/images/icons/catering-icons/tooltip-icon.svg";
import { RESTAURANT_LEVEL_HEX_COLOR } from "../../../../../core/constant";
import { getRestaurantPageData } from "../../../_request";
import formatNumberWithCommas from "../../../../../core/utils/formatNumberWithCommas";
export default function data({ topRestaurantData }) {
  const progressObj = {};

  const progressLimit = (data, currentTier, totalOrderAmountInCents) => {
    let eligibleSaleAmountInCentsData = data?.loyalty_plans
      .map((e) => e.eligibleSaleAmountInCents)
      .sort((a, b) => a - b);
    const myProgress = totalOrderAmountInCents;
    if (currentTier) {
      data?.loyalty_plans.forEach((element, index) => {
        if (element.name === currentTier) {
          progressObj.lv = element.eligibleSaleAmountInCents;
          if (currentTier === "Level 3") {
            progressObj.hv = null;
          } else if (currentTier === "Level 2") {
            progressObj.hv = eligibleSaleAmountInCentsData[2];
          } else {
            progressObj.hv = eligibleSaleAmountInCentsData[1];
          }
        }
      });
    } else {
      data?.loyalty_plans.forEach((element, index) => {
        if (element.name === "Level 1") {
          progressObj.lv = element.eligibleSaleAmountInCents;
          progressObj.hv = eligibleSaleAmountInCentsData[1];
        }
      });
    }
    let progress = 100;
    if (progressObj.hv) {
      progressObj.range = progressObj.hv - progressObj.lv;
      progressObj.progressLeft = ((progressObj.hv - myProgress) / 100 + 0.01).toFixed(2);
      progress = ((myProgress - progressObj.lv) / progressObj.range) * 100;
    }
    return progress;
  };

  const setplanDetails = (data, currentTier) => {
    let loyalty_plans_details = [];
    if (currentTier) {
      for (const plan of data) {
        if (plan.name === currentTier) {
          loyalty_plans_details = plan.loyalty_plans_details
            .slice()
            .sort((a, b) => a.cashbackMultiple_100 - b.cashbackMultiple_100);
          break;
        }
      }
    } else {
      for (const plan of data) {
        if (plan.name === "Level 1") {
          loyalty_plans_details = plan.loyalty_plans_details
            .slice()
            .sort((a, b) => a.cashbackMultiple_100 - b.cashbackMultiple_100);
          break;
        }
      }
    }
    return loyalty_plans_details;
  };

  const getRestaurantPageDetails = async (prefix) => {
    try {
      const {
        data: {
          success,
          data: { restaurantPageObj },
        },
      } = await getRestaurantPageData(prefix);
      if (success) {
        return restaurantPageObj.orderNowUrl;
      }
    } catch (err) {
      console.log(err);
    }
  };

  return {
    columns: [
      { Header: "RESTAURANT NAME", accessor: "restaurantName", width: "25%", align: "left" },
      { Header: "LOCATION", accessor: "location", align: "left" },
      { Header: "ORDERS SINCE ANNIVERSARY", accessor: "last12Months", align: "center" },
      { Header: "ANNIVERSARY DATE", accessor: "anniversaryDate", align: "center" },
      { Header: "MAX CASHBACK", accessor: "maxCashback", align: "center" },
      {
        Header: "CURRENT TIER",
        accessor: "progress",
      },
    ],

    rows: topRestaurantData?.map((data) => {
      const progress = progressLimit(
        data?._restaurant_store_restaurant_store?._loyalty_plan_set_loyalty_plan_set,
        data.currentLevel,
        data?.totalSpendSinceAnniversary
      );
      const planDetails = setplanDetails(
        data?._restaurant_store_restaurant_store?._loyalty_plan_set_loyalty_plan_set?.loyalty_plans,
        data.currentLevel
      );
      return {
        restaurantName: (
          <MDBox
            display="flex"
            alignItems="center"
            lineHeight={1}
            component="a"
            onClick={async () => {
              let orderNowUrl = await getRestaurantPageDetails(
                data._restaurant_store_restaurant_store.restaurantPrefix
              );
              if (orderNowUrl) {
                window.open(orderNowUrl, "_blank");
              } else {
                window.open(
                  `${
                    config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"]
                      .API_LANDING_PAGE_BASE_URL
                  }/restaurants/${data._restaurant_store_restaurant_store.restaurantPrefix}`,
                  "_blank"
                );
              }
            }}
            target="_blank"
            sx={{ cursor: "pointer" }}
          >
            <MDTypography variant="button" fontWeight="medium" lineHeight={1}>
              {data._restaurant_store_restaurant_store.name}
            </MDTypography>
          </MDBox>
        ),
        location: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {data?._restaurant_store_restaurant_store.storeAddressLine1 &&
              data?._restaurant_store_restaurant_store.storeAddressLine1.slice(0, 17)}
            {"..."}
          </MDTypography>
        ),
        last12Months: (
          <MDBox sx={{ display: "flex", gap: 1 }}>
            <MDTypography variant="caption" color="text" fontWeight="medium">
              $
              {data?.totalSpendSinceAnniversary
                ? formatNumberWithCommas(data?.totalSpendSinceAnniversary / 100)
                : 0}
            </MDTypography>
            <Tooltip
              key={"amount-reset-info"}
              title={
                <div style={{ textAlign: "left" }}>
                  This amount resets on your anniversary date each year.
                </div>
              }
              placement="bottom"
            >
              <MDAvatar
                src={tooltipIcon}
                name={"amount-reset-info"}
                size="sm"
                sx={{ width: 15, height: 15 }}
              />
            </Tooltip>
          </MDBox>
        ),
        anniversaryDate: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {data.anniversaryDate
              ? new Date(data.anniversaryDate).toLocaleDateString("en-US", {
                  timeZone: "UTC",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : "-"}
          </MDTypography>
        ),
        maxCashback: (
          <MDBox sx={{ display: "flex", gap: 1 }}>
            <MDTypography
              variant="caption"
              color="text"
              fontWeight="medium"
              component="a"
              href={`${
                config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"]
                  .API_LANDING_PAGE_BASE_URL
              }/restaurants/${data._restaurant_store_restaurant_store.restaurantPrefix}`}
              target="_blank"
            >
              {!!planDetails && planDetails[planDetails.length - 1]?.cashbackMultiple_100
                ? planDetails[planDetails.length - 1]?.cashbackMultiple_100 / 100 + "X"
                : "-"}
            </MDTypography>
            <Tooltip
              key={"maxCashback"}
              title={
                <div style={{ textAlign: "left" }}>
                  {planDetails.length === 1 ? (
                    <div>
                      ${(planDetails[0].minimumSaleInCents / 100).toFixed(2)} onwards:{" "}
                      {planDetails[0].cashbackMultiple_100 / 100}X
                    </div>
                  ) : (
                    planDetails.map((plan, index) => (
                      <div key={index}>
                        <div>
                          {index === planDetails.length - 1
                            ? `$${plan.minimumSaleInCents / 100} onwards: ${
                                plan.cashbackMultiple_100 / 100
                              }X`
                            : `$${plan.minimumSaleInCents / 100} to $${
                                plan.maximumSaleInCents / 100
                              }: ${plan.cashbackMultiple_100 / 100}X `}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              }
              placeholder="bottom"
            >
              <MDAvatar
                src={tooltipIcon}
                name={"maxCashback"}
                size="sm"
                sx={{ width: 15, height: 15 }}
              />
            </Tooltip>
          </MDBox>
        ),
        progress: data.currentLevel ? (
          <Tooltip
            key={"progress"}
            title={
              progressObj.hv
                ? `$${progressObj.progressLeft} left to reach next level above $${(
                    progressObj.hv / 100
                  ).toFixed(2)}`
                : `Congratulations on reaching the highest level! You've spent a total of $${formatNumberWithCommas(
                    data?.totalSpendSinceAnniversary / 100
                  )}. Enjoy the perks!`
            }
            placeholder="bottom"
          >
            <MDBox width="84px" textAlign="left">
              <MDBox
                sx={{
                  backgroundColor:
                    RESTAURANT_LEVEL_HEX_COLOR[data.currentLevel ? data.currentLevel : "Level 1"],
                  borderRadius: "4px",
                  padding: "5px",
                  position: "relative",
                }}
              >
                <MDBox
                  sx={{
                    height: "100%",
                    width: `${100 - progress}%`,
                    backgroundColor: "rgba(255, 255, 255, 0.65)",
                    position: "absolute",
                    top: 0,
                    right: 0,
                    bottom: 0,
                  }}
                ></MDBox>
                <MDBox
                  sx={{
                    color: "#FFFFFF",
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "18px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1,
                  }}
                >
                  {data.currentLevel ? data.currentLevel : "Level 1"}
                </MDBox>
              </MDBox>
            </MDBox>
          </Tooltip>
        ) : (
          <Tooltip
            key={"progress"}
            title={"No order is eligible for cashback"}
            placeholder="bottom"
          >
            <MDBox width="40px">
              <MDTypography variant="caption" color="text" fontWeight="medium" width="100%">
                {data.currentLevel ? data.currentLevel : "NA"}
              </MDTypography>
            </MDBox>
          </Tooltip>
        ),
      };
    }),
  };
}

data.PropTypes = {
  topRestaurantData: PropTypes.any,
};
